export function salvarTamanho(tamanho) {
  localStorage.setItem('pptam', tamanho);
}

export function usarTamanhoSalvo(tam) {
  let currentTam = typeof tam !== 'undefined' ? tam : localStorage.getItem('pptam');
  console.log('usarTamanhoSalvo ', currentTam);
  $('[data-tamanho-set="' + currentTam + '"]').click();
}
